
import React, { useEffect, useState, useRef, useCallback } from "react";
import cn from "classnames";
import StatusComponent from "components/StatusComponent";
import SwappingComponent from "components/SwappingComponent";
import EnergyComponent from "components/EnergyComponent";
import FaultsComponent from "components/FaultsComponent";
import styles from "./Dashboard.module.scss";
import Button from "@material-ui/core/Button";
import LocalStorageService from "services/tokenlocalstorage.service";
import { getRequest, postRequest } from "services/axiosBaseClient";
import { getRequestInAssets } from "services/axiosAssetsBaseClient";
import notificationService from "services/notification.service";
import Master from "screen/Master";
import GoogleMap from "components/googlemap/GoogleMap";

function DashboardView(props) {
  const filterInitialValue = {
    siteId: "",
    swapStationId: "",
    stateId: "",
    cityId: "",
    zoneId: "",
    timeFilterEnum: "HOUR_24",
    state: "",
    city: "",
  };

  const [sitesList, setSitesList] = useState([]);
  const [chargerList, setChargerList] = useState([]);

  const [userRole, setUserRole] = useState("");
  const [navigation, setNavigation] = useState(false);
  const [open, setOpen] = useState(false);
  const refOpen = useRef(open);
  const useMyEmailRef = useRef();

  const [siteStatus, setSiteStatus] = useState([]);
  const [swap, setSwap] = useState([]);
  const [batteriesSwap, getBatteriesSwap] = useState([]);
  const [alert, setAlert] = useState([]);
  const [filter, setFilter] = useState(filterInitialValue);
  const [selectTimeValue, setSelectTimeValue] = useState("HOUR_24");
  const [selectTime, setSelectTime] = useState("HOUR_24");
  const [energyGraph, setEnergyGraph] = useState();
  const [swappingGraph, setSwappingGraph] = useState();
  const [fault, setFault] = useState([]);
  const [alertDetail, setAlertDetail] = useState([]);
  const [faultGraphLoading, setFaultGraphLoading] = useState(false);

  const [loading, setLoading] = useState(false);

  const [batteryStatus, setBatteryStatus] = useState([]);
  function useOutsideAlerter(ref, ref1) {

    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpen(false);
          refOpen.current = false;
        } else {
          if (
            refOpen.current &&
            ref1.current &&
            !ref1.current.contains(event.target)
          ) {
            refOpen.current = false;
            setOpen(false);
          } else {
            setOpen(true);
            refOpen.current = true;
          }
        }
      }

      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, ref1]);
  }

  const wrapperRef = useRef(null);
  const wrapperRefInside = useRef(null);

  useOutsideAlerter(wrapperRef, wrapperRefInside);

  const handleClick = (btnType) => {
    if (open) {
      if (btnType == "reset") {
        filter.timeFilterEnum = filterInitialValue.timeFilterEnum;
        filter.swapStationId = "";
        filter.siteId = "";
        setSelectTimeValue(filterInitialValue.timeFilterEnum);
        getEnergyGraph(filter);
        getSwappingGraph(filter);
        getFaultGraph(filter);
        getBatteryCountAndStatus(filter);
        setChargerList([]);
      } else {
        setSelectTimeValue(selectTime);
        getEnergyGraph(filter);
        getSwappingGraph(filter);
        getFaultGraph(filter);
        getBatteryCountAndStatus(filter);
      }
      setOpen(false);
    } else {
      setOpen(true);
    }
  };

  const alertDetails = {
    statusCode: 200,
    message: "Alert Details fetched successfully",
    error: false,
    data: {
      temperature: 0,
      upcomingSwaps: 0,
      alerts: 0,
    },
  };

  const getAlertDetails =  () => {
    let callString = "bss/getAlertDetails";
    if (filter.cityId > 0) {
      callString += "?cityId=" + filter.cityId;
      if (filter.stateId > 0) {
        callString += "&stateId=" + filter.stateId;
      }
      if (filter.zoneId > 0) {
        callString += "&zoneId=" + filter.zoneId;
      }
    } else if (filter.stateId > 0) {
      callString += "?stateId=" + filter.stateId;

      if (filter.zoneId > 0) {
        callString += "&zoneId=" + filter.zoneId;
      }
    } else if (filter.zoneId > 0) {
      callString += "?zoneId=" + filter.zoneId;
    }
     getRequest(callString).then((res) => {
      if (res && res?.data) {
        setAlertDetail(res?.data);
        return;
      }
    });
  };

  const getSites = useCallback(async (filter) => {

    let callString = "bss/site/siteList";
    if (filter.cityId > 0) {
      callString += "?cityId=" + filter.cityId;
      if (filter.stateId > 0) {
        callString += "&stateId=" + filter.stateId;
      }
      if (filter.zoneId > 0) {
        callString += "&zoneId=" + filter.zoneId;
      }
    } else if (filter.stateId > 0) {
      callString += "?stateId=" + filter.stateId;

      if (filter.zoneId > 0) {
        callString += "&zoneId=" + filter.zoneId;
      }
    } else if (filter.zoneId > 0) {
      callString += "?zoneId=" + filter.zoneId;
    }
    // ?endDate=" +
    //     payload.endDate +
    //     "&siteId=" +
    //     payload.siteId +
    //     "&startDate=" +
    //     payload.startDate
    await getRequestInAssets(callString)
      .then((res) => {
        if (res.data != null) {
          setSitesList(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getChargers = useCallback(async (siteId) => {
    await getRequestInAssets(
      `bss/swappingStation/getAllSwappingStationsBySite?siteId=${siteId}`
    )
      .then((res) => {
        if (res.data != null) {
          setChargerList(res?.data);
          return;
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getSiteStatus = useCallback(async (filter) => {
    var tempFilter = {
      swapStationId: filter.swapStationId,
      zoneId: filter.zoneId,
      siteId: filter.siteId,
      cityId: filter.cityId,
      stateId: filter.stateId,
      timeFilterEnum: filter.timeFilterEnum,
    };

    await postRequest("bss/getSiteStatus", tempFilter)
      .then((res) => {
        if (res.data != null) {
          setSiteStatus(res.data);
          return;
        }
      })
      .catch((err) => {
        console.error("Error", err);
        return;
      });
  }, []);

  const getSwapStatus = useCallback(async (filter) => {
    var tempFilter = {
      swapStationId: filter.swapStationId,
      zoneId: filter.zoneId,
      siteId: filter.siteId,
      cityId: filter.cityId,
      stateId: filter.stateId,
      timeFilterEnum: filter.timeFilterEnum,
    };
    await postRequest("bss/getSwappedStationStatus", tempFilter)
      .then((res) => {
        if (res.data != null) {
          setSwap(res.data);
          return;
        }
      })
      .catch((err) => {
        console.error("Error", err);
        return;
      });
  }, []);

  const getBatteriesStatus = useCallback(async (filter) => {
    var tempFilter = {
      swapStationId: filter.swapStationId,
      zoneId: filter.zoneId,
      siteId: filter.siteId,
      cityId: filter.cityId,
      stateId: filter.stateId,
      timeFilterEnum: filter.timeFilterEnum,
    };
    await postRequest("bss/getBatteriesStatusInSwappedStation", tempFilter)
      .then((res) => {
        if (res.data != null) {
          getBatteriesSwap(res.data);
          return;
        }
      })
      .catch((error) => {
        notificationService.showNonBlacklistedError(
          error?.config?.url,
          error?.response?.data?.message
        );
      });
  }, []);

  // const getAlertStatus = useCallback(async () => {
  //   await postRequest("bss/getAlertDetails", filter)
  //     .then((res) => {
  //       if (res.data != null) {
  //         setAlert(res.data);
  //       }
  //     })
  //     .catch((err) => {
  //       console.error("Error", err);
  //     });
  // }, []);

  const getEnergyGraph = useCallback(async (filter) => {
    var tempFilter = {
      swapStationId: filter.swapStationId,
      zoneId: filter.zoneId,
      siteId: filter.siteId,
      cityId: filter.cityId,
      stateId: filter.stateId,
      timeFilterEnum: filter.timeFilterEnum,
    };
    await postRequest("bss/dashboard/swappedEnergyGraph", tempFilter)
      .then((res) => {
        if (res.data != null) {
          setEnergyGraph(res.data);
          return;
        }
      })
      .catch((error) => {
        notificationService.showNonBlacklistedError(
          error?.config?.url,
          error?.response?.data?.message
        );
      });
  }, []);

  const getSwappingGraph = useCallback(async (filter) => {
    var tempFilter = {
      swapStationId: filter.swapStationId,
      zoneId: filter.zoneId,
      siteId: filter.siteId,
      cityId: filter.cityId,
      stateId: filter.stateId,
      timeFilterEnum: filter.timeFilterEnum,
    };
    await postRequest("bss/dashboard/swappingCountGraph", tempFilter)
      .then((res) => {
        if (res.data != null) {
          setSwappingGraph(res.data);
          return;
        }
      })
      .catch((error) => {
        notificationService.showNonBlacklistedError(
          error?.config?.url,
          error?.response?.data?.message
        );
      });
  }, []);

  const getFaultGraph = useCallback(async (filter) => {
    setFaultGraphLoading(true);
    var tempFilter = {
      swapStationId: filter.swapStationId,
      zoneId: filter.zoneId,
      siteId: filter.siteId,
      cityId: filter.cityId,
      stateId: filter.stateId,
      timeFilterEnum: filter.timeFilterEnum,
    };
    await postRequest("bss/getBatteriesAndChargerFaultDetail", tempFilter)
      .then((res) => {
        if (res?.data != null) {
          setFault(res?.data);
        } else {
          setFault({
            totalFault: 0,
            totalChargerFaulted: 0,
            totalBatteryFaulted: 0,
          });
        }
        setFaultGraphLoading(false)
        return;
      })
      .catch((err) => {
        console.error("Error", err);
        return;
      });
  }, []);

  const getBatteryCountAndStatus = useCallback(async (filter) => {
    setLoading(true);
    var tempFilter = {
      swapStationId: filter.swapStationId,
      zoneId: filter.zoneId,
      siteId: filter.siteId,
      cityId: filter.cityId,
      stateId: filter.stateId,
    };
    var BatteriesData=[];
    await postRequest("bss/batteryStatusGraph", tempFilter)
      .then((res) => {
        if (res.data != null) {
          BatteriesData = res.data.map(function (markerdata) {
            var data = {
              id: markerdata.siteId,
              lat: markerdata.latitude,
              lng: markerdata.longitude,
              siteId: markerdata.siteId,
              siteName: markerdata.siteName,
              charged: markerdata.totalCharged,
              charging: markerdata.totalCharging,
              fault: markerdata.totalFault,
            };
            return data;
          });
          BatteriesData["date"] = Date.now();
          setBatteryStatus(BatteriesData);
        }
      }).catch((error) => {
        notificationService.showNonBlacklistedError(
          error?.config?.url,
          error?.response?.data?.message
        );
        BatteriesData["date"] = Date.now();
        setBatteryStatus(BatteriesData);
        return error;
      });
      
    setLoading(false);
  }, []);

  setTimeout(() => {
    if (navigation === false) {
      setNavigation(null);
    }
  }, 500);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFilter({ ...filter, [name]: value });
    if (event.target.name == "timeFilterEnum") {
      setSelectTime(event.target.value);
    }
    if (event.target.name == "siteId") {
      setFilter({ ...filter, [name]: value, swapStationId: "" });
      getChargers(event.target.value);
    }
  };

  const getTime = (val) => {
    const endTime = Math.round(new Date().getTime() / 1000);
    const startTime = endTime - val * 3600;

    //filter.endDate = endTime;
    //filter.startDate = startTime;
  };

  useEffect( () => {

    const headerFilterObj = JSON.parse(LocalStorageService.get("headerFilter"));
    if (headerFilterObj !== null) {
      filter.stateId = headerFilterObj.stateId;
      filter.cityId = headerFilterObj.cityId;
      filter.zoneId = headerFilterObj.zoneId;
      filter.state = headerFilterObj.state;
      filter.city = headerFilterObj.city;
    }
    const script = document.createElement("script");
    script.src =
      "https://maps.googleapis.com/maps/api/js?key=" +
      process.env.REACT_APP_GOOGLE_API_KEY;
    script.async = true;
    document.body.appendChild(script);

    //getTime(24);
    getAlertDetails();
    //getSites();
    getSites(filter);
    getSiteStatus(filter);
    getSwapStatus(filter);
    getBatteriesStatus(filter);
    getEnergyGraph(filter);
    getFaultGraph(filter);
    getSwappingGraph(filter);
    getBatteryCountAndStatus(filter);
    setUserRole(LocalStorageService.get("user-role"));
    return;
  }, [props.headerFilter]);

  const handlingRefresh = () => {
    window.location.reload();
  };

  useEffect(() => {
    console.log(useMyEmailRef.current, "useMyEmailRef");
  }, []);

  return (
    <>
      <h2 id="Dashboard_Title" className={cn(styles.medium_title, styles.medium_title_layout)}>
        {userRole.toLowerCase() === "admin"
          ? "Admin Dashboard"
          : "Operator Dashboard"}
      </h2>
      {/* <button onClick={handlingRefresh}>
        Refresh page
      </button> */}

      <div
      id="Dashboard_Main_Card"
        className={cn(styles.card_list_block, styles.card_list_block_layout)}
      >
        <div id="Dashboard_Main_Card" className={cn(styles.status_flex, styles.status_flex_layout)}>
          <div id="Dashboard_SiteStatus_Card" className={cn(styles.status_flex_item)}>
            <div
            id="Dashboard_SiteStatus_block"
              className={cn(styles.status_block, styles.status_block_layout)}
            >
              <div id="Dashboard_SiteStatus_layout" className={cn(styles.component, styles.component_layout)}>
                <StatusComponent
                  ic_background={"#4A81D4"}
                  ic={require("assets/energy.png").default}
                  progress1color={"#8E54E9"}
                  progress2color={"#FCC644"}
                  progress3color={"#C4C4C3"}
                  progress1name={
                    userRole.toLowerCase() === "admin"
                      ? "Total Sites"
                      : "Online"
                  }
                  progress2name={
                    userRole.toLowerCase() === "admin" ? "Working" : "Offline"
                  }
                  progress3name={"Under Maintenance"}
                  progress1percent={
                    userRole.toLowerCase() === "admin"
                      ? siteStatus.totalSites == undefined
                        ? 0
                        : siteStatus.totalSites
                      : siteStatus.online == undefined
                      ? 0
                      : siteStatus.online
                  }
                  progress2percent={
                    userRole.toLowerCase() === "admin"
                      ? siteStatus.online == undefined
                        ? 0
                        : siteStatus.online
                      : siteStatus.offline == undefined
                      ? 0
                      : siteStatus.offline
                  }
                  progress3percent={
                    siteStatus.underMaintainance == undefined
                      ? 0
                      : siteStatus.underMaintainance
                  }
                  header={"Site Status"}
                />
              </div>
            </div>
          </div>
          <div className={cn(styles.flex4_spacer)} />

          <div id="Dashboard_SwapStation_Card" className={cn(styles.status_flex_item)}>
            <div
            id="Dashboard_SwapStation_block"
              className={cn(styles.status_block, styles.status_block_layout)}
            >
              <div id="Dashboard_SwapStation_layout" className={cn(styles.component, styles.component_layout)}>
                <StatusComponent
                  ic_background={"#fcc644ff"}
                  ic={require("assets/charger-status.png").default}
                  progress1color={"#00792C"}
                  progress2color={"#E3324C"}
                  progress3color={"#C4C4C3"}
                  progress1name={"Healthy"}
                  progress2name={"Fault"}
                  progress3name={"Under Maintenance"}
                  progress1percent={
                    swap.healthy == undefined ? 0 : swap.healthy
                  }
                  progress2percent={swap.fault == undefined ? 0 : swap.fault}
                  progress3percent={
                    swap.underMaintainance == undefined
                      ? 0
                      : swap.underMaintainance
                  }
                  header={"Swap Station"}
                />
              </div>
            </div>
          </div>
          <div className={cn(styles.flex4_spacer1)} />
          <div id="Dashboard_BatteryStatus_Card" className={cn(styles.status_flex_item)}>
            <div
            id="Dashboard_BatteryStatus_block"
              className={cn(styles.status_block, styles.status_block_layout)}
            >
              <div id="Dashboard_BatteryStatus_layout" className={cn(styles.component, styles.component_layout)}>
                <StatusComponent
                  ic_background={"#11CA6D"}
                  ic={require("assets/battery1.png").default}
                  progress1color={"#00792C"}
                  progress2color={"#FCC644"}
                  progress3color={"#E3324C"}
                  progress1name={
                    userRole.toLowerCase() === "admin" ? "Available" : "Charged"
                  }
                  progress2name={"Charging"}
                  progress3name={"Fault"}
                  progress1percent={
                    batteriesSwap.charged == undefined
                      ? 0
                      : batteriesSwap.charged
                  }
                  progress2percent={
                    batteriesSwap.charging == undefined
                      ? 0
                      : batteriesSwap.charging
                  }
                  progress3percent={
                    batteriesSwap.fault == undefined ? 0 : batteriesSwap.fault
                  }
                  header={
                    userRole.toLowerCase() === "admin"
                      ? "Battery Status"
                      : "Batteries in Swap Station"
                  }
                />
              </div>
            </div>
          </div>
          <div className={cn(styles.flex4_spacer)} />
          <div id="Dashboard_Alerts_Card" className={cn(styles.status_flex_item)}>
            <div
            id="Dashboard_Alerts_block"
              className={cn(styles.status_block, styles.status_block_layout)}
            >
              <div id="Dashboard_Alerts_layout" className={cn(styles.component, styles.component_layout)}>
                <StatusComponent
                  ic_background={"#E3324C"}
                  ic={require("assets/Vector(10).png").default}
                  progress1color={"#DE6421"}
                  progress2color={"#8E54E9"}
                  progress3color={"#E3324C"}
                  progress1name={"Temperature"}
                  progress2name={"Upcoming Swapping"}
                  progress3name={"Alerts"}
                  progress1percent={
                    alertDetail.temperature === null ||
                    alertDetail.temperature === undefined
                      ? 0
                      : alertDetail.temperature
                  }
                  progress2percent={
                    alertDetail.upcomingSwaps === null ||
                    alertDetail.upcomingSwaps === undefined
                      ? 0
                      : alertDetail.upcomingSwaps
                  }
                  progress3percent={
                    alertDetail.alerts === null ||
                    alertDetail.alerts === undefined
                      ? 0
                      : alertDetail.alerts
                  }
                  header={"Alerts"}
                />
              </div>
            </div>
          </div>
        </div>

        <hr className={cn(styles.line1, styles.line1_layout)} />

        <div
        id="Dashboard_Graph_Filter"
          ref={wrapperRef}
          style={{ cursor: "pointer" }}
          className={cn(
            styles.graph_filter_block,
            styles.graph_filter_block_layout
          )}
        >
          <div
          id="Dashboard_Graph_FilterTextBlock"
            className={cn(
              styles.graph_filter_text_block,
              styles.graph_filter_text_block_layout
            )}
          >
            <div id="Dashboard_Graph_FilterText" className={cn(styles.text_body, styles.text_body_layout)}>
              {"Filters"}
            </div>
          </div>

          <div id="Dashboard_Graph_FilterBox" className={cn(styles.box16, styles.box16_layout)}>
            <img
            id="Dashboard_Graph_FilterImg"
              src={require("assets/Vector.svg").default}
              className={cn(styles.box1, styles.box1_layout)}
            />
            <div>
              <div>
                {open && (
                  <div id="filter" open={open} 
                  ref={wrapperRefInside}
                  >
                    <div
                    id="Graph_Filter_block"
                      className={cn(
                        styles.status1_block,
                        styles.status1_block_layout
                      )}
                    >
                      <div id="Graph_SelectTime">
                        <select
                          style={{ width: "80%", height: "35px" }}
                          name="timeFilterEnum"
                          id="timeFilterEnum"
                          onChange={handleChange}
                          value={filter.timeFilterEnum}
                        >
                          <option value="-1" disabled >
                          Select Time Period
                          </option>
                          <option value="HOUR_24" selected>Last 24 hours</option>
                          <option value="HOUR_12">Last 12 hours</option>
                          <option value="WEEK">Last 1 week</option>
                          <option value="WEEK_2">Last 2 weeks</option>
                          <option value="MONTH">Last 1 month</option>
                          <option value="MONTH_3">Last 3 months</option>
                        </select>
                      </div>

                      <div id="Graph_SelectSite">
                        <select
                          style={{ width: "80%", height: "35px" }}
                          name="siteId"
                          id="siteId"
                          onChange={handleChange}
                          value={filter.siteId}
                        >
                          <option value="" disabled selected>
                          Select Site
                          </option>
                          {sitesList.map((obj) => {
                            return <option value={obj.id}>{obj.name}</option>;
                          })}
                        </select>
                      </div>

                      <div id="Graph_SelectSwapStation">
                        <select
                          style={{ width: "80%", height: "35px" }}
                          name="swapStationId"
                          id="swapStationId"
                          onChange={handleChange}
                          value={filter.swapStationId}
                        >
                          <option value="" disabled selected>
                          Select Swap Station
                          </option>
                          {chargerList.map((obj) => {
                            return <option value={obj.id}>{obj.name}</option>;
                          })}
                        </select>
                      </div>

                      <div >
                        <Button
                        id="Graph_Reset_Button"
                          style={{
                            background: "#E3324C",
                            color: "white",
                            margin: "15px 0px 6px 35px",
                            width: "85px",
                            height: "28px",
                          }}
                          onClick={() => handleClick("reset")}
                        >
                          Reset
                        </Button>
                        <Button
                        id="Graph_Apply_Button"
                          style={{
                            background: "#23297A",
                            color: "white",
                            margin: "15px 0px 6px 20px",
                            width: "85px",
                            height: "28px",
                          }}
                          onClick={() => handleClick("apply")}
                        >
                          Apply
                        </Button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div id="Dashboard_energyGraph_layout"
          className={cn(
            styles.upper_graph_flex,
            styles.upper_graph_flex_layout
          )}
        >
          <div id="Dashboard_energyGraph_layout1" className={cn(styles.upper_graph_flex_item)}>
            <div
            id="Dashboard_energyGraph_block"
              className={cn(
                styles.graph_card_view,
                styles.graph_card_view_layout
              )}
            >
              <div id="Dashboard_energyGraph" className={cn(styles.block17, styles.block17_layout)}>
                <h5
                id="Dashboard_energyGraph_Heading"
                  className={cn(styles.highlights1, styles.highlights1_layout)}
                >
                  {"Energy Graph"}
                </h5>
                {/* <div> */}
                <EnergyComponent
                  styles={{ with: "100%", height: "100%" }}
                  data={energyGraph}
                  selectValue={selectTimeValue}
                />
                {/* </div> */}
              </div>
            </div>
          </div>
          <div className={cn(styles.upper_graph_flex_spacer)} />
          <div id="Dashboard_SwappingGraph_layout" className={cn(styles.upper_graph_flex_item)}>
            <div
            id="Dashboard_SwappingGraph_block"
              className={cn(
                styles.graph_card_view,
                styles.graph_card_view_layout
              )}
            >
              <div id="Dashboard_SwappingGraph" className={cn(styles.block17, styles.block17_layout)}>
                <h5 id="Dashboard_SwappingGraph_Heading"
                  className={cn(styles.highlights1, styles.highlights1_layout)}
                >
                  {"Swapping Graph"}
                </h5>
                {/* <div> */}
                <SwappingComponent
                  styles={{ with: "100%", height: "80%" }}
                  data={swappingGraph}
                  selectValue={selectTimeValue}
                />
                {/* </div> */}
              </div>
            </div>
          </div>
          <div className={cn(styles.upper_graph_flex_spacer)} />
          <div id="Dashboard_FaultsGraph_layout" className={cn(styles.upper_graph_flex_item)}>
            <div
            id="Dashboard_FaultsGraph_block"
              className={cn(
                styles.graph_card_view,
                styles.graph_card_view_layout1
              )}
            >
              <div  id="Dashboard_FaultsGraph" className={cn(styles.block17, styles.block17_layout)}>
                <h5  id="Dashboard_FaultsGraph_Heading"
                  className={cn(styles.highlights1, styles.highlights1_layout)}
                >
                  {"Faults"}
                </h5>
                {
                  faultGraphLoading ? <></>
                 :
                <FaultsComponent
                styles={{ with: "100%", height: "100%" }}
                data={fault}
                selectValue={selectTimeValue}
              />
                }
              </div>
            </div>
          </div>
        </div>
        <hr className={cn(styles.line1, styles.line1_layout)} />
        <div className={cn(styles.upper_graph_flex_spacer)} />
        <div  id="Dashboard_GoogleMap"className={cn(styles.map_card)}>
          <h5
          id="Dashboard_GoogleMap_Heading"
            className={cn(styles.map_card_title, styles.map_card_title_layout)}
          >
            {userRole.toLowerCase() === "admin"
              ? "Region Status"
              : "Battery Count and Status"}
          </h5>
          {!loading && (
            <div id="Dashboard_GoogleMap_layout"
              className={cn(
                styles.status_block_map,
                styles.status_block_layout_map
              )}
            >
              <div id="GoogleMap_statusBlock" className={cn(styles.map_status_card_layout)}>
                <div id="GoogleMap_statusInnerBlock" className={cn(styles.map_status_card_text)}>
                  <div
                  id="GoogleMap_statusInnerBlock_AvailableText"
                    style={{
                      backgroundColor: "#087A3E",
                      borderRadius: "50%",
                      height: "14px",
                      width: "14px",
                      margin: "10px",
                    }}
                  ></div>
                  {userRole.toLowerCase() === "admin" ? "Available" : "Charged"}
                </div>

                <div className={cn(styles.map_status_card_text)}>
                  <div
                  id="GoogleMap_statusInnerBlock_ChargingText"
                    style={{
                      backgroundColor: "#FCC644",
                      borderRadius: "50%",
                      height: "14px",
                      width: "14px",
                      margin: "10px",
                    }}
                  ></div>
                  {"Charging"}
                </div>

                <div className={cn(styles.map_status_card_text)}>
                  <div
                  id="GoogleMap_statusInnerBlock_FaultText"
                    style={{
                      backgroundColor: "#E3324C",
                      borderRadius: "50%",
                      height: "14px",
                      width: "14px",
                      margin: "10px",
                    }}
                  ></div>
                  {"Fault"}
                </div>
              </div>
            </div>
          )}
          <GoogleMap key={batteryStatus.date} data={batteryStatus} />
        </div>
      </div>
    </>
  );
}

export default function Dashboard(props) {
  let Urls = window.location.href.toString().split(window.location.host)[1];
  const [headerFilter, setHeaderFilter] = useState(true);

  return (
    <>
      <Master
        dashboardName={Urls}
        opts={
          props 
      }
        screen={DashboardView}
        showStatus={true}
        headerFilter={headerFilter}
        setHeaderFilter={setHeaderFilter}
      />
    </>
  );
}

Dashboard.inStorybook = true;
